module.exports = __webpack_public_path__ + "../resources/images/drophint_2x_s_bw-d1fd7a02986577bb2a8df3229cd01657.png";